import { types } from 'mobx-state-tree';

import { 
    NumSmokeDetectorValues,
    NumFireExtinguisherValues,
    BurglarAlarmValues,
    FireAlarmValues,
} from '../definitions/InsCommon';


export default types
    .model('OtherInformationModel', {
        hasCAAMembership: types.maybeNull(types.boolean),
        fireAlarmType: types.maybeNull(
            types.enumeration(Object.values(FireAlarmValues)),
        ),
        isSmoker: types.maybeNull(types.boolean),

        // These values are defaulted as of INS-2950
        hasEntranceLocks: types.optional(
            types.boolean,
            true,
        ),
        hasFireSprinkler: types.optional(
            types.boolean,
            false,
        ),
        burglarAlarmType: types.optional(
            types.enumeration(Object.values(BurglarAlarmValues)),
            BurglarAlarmValues.NONE,
        ),
        numSmokeDetectors: types.optional(
            types.enumeration(Object.values(NumSmokeDetectorValues)),
            NumSmokeDetectorValues.TWO,
        ),
        numFireExtinguishers: types.optional(
            types.enumeration(Object.values(NumFireExtinguisherValues)),
            NumFireExtinguisherValues.ZERO,
        ),
    })
    .views(self => ({
        get isValid() {
            return (
                self.hasCAAMembership != null
                && self.burglarAlarmType != null
                && self.fireAlarmType != null
                && self.hasEntranceLocks != null
                && self.numSmokeDetectors != null
                && self.numFireExtinguishers != null
                && self.hasFireSprinkler != null
                && self.isSmoker != null
            );
        },
    }));
